import {comMapping} from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        pz_searchlist: [
            {
                prop: "accountCode",
                label: '科目代码',
                type: "input"
            },
            {
                prop: "postingDate",
                label: '记账日期',
                type: "date",
                valueformat: 'yyyy-MM-dd'
            },
            {
                prop: "voucherDesc",
                label: '凭证摘要',
                type: "input"
            },
            {
                prop: "voucherNo",
                label: '凭证号',
                type: "input"
            }
        ],
        pz_searchdata: {
            accountCode: "",
            postingDate: [],
            voucherDesc: "",
            voucherNo: "",
        },
        pz_headData: [
            {
                title: "科目代码",
                prop: "accountCode",
                width: "110",
                custom: true,
                issort: true,
            },
            {
                title: "凭证号",
                custom: true,
                prop: "voucherNo",
                width: 110,
                issort: true,
            },
            {
                custom: true,
                title: "记账日期",
                prop: "postingDate",
                width: 110,
                issort: true,
            },
            {
                title: "记账金额",
                custom: true,
                prop: "localAmount",
                width: 100,
                issort: true,
            },
            {
                title: "凭证摘要",
                custom: true,
                prop: "voucherDesc",
                width: 110,
                issort: true,
            },
            {
                title: "记账人",
                custom: true,
                prop: "accounting",
                width: 100,
                issort: true,
            },
        ],
        pz_pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        },

        fp_searchlist: [
            {
                prop: "faphm",
                label: '发票号码',
                type: "input"
            },
            {
                prop: "kaiprq",
                label: '开票日期',
                type: "date",
                valueformat: 'yyyyMMdd'
            },
            {
                prop: "xiaofmc",
                label: '销方名称',
                type: "input"
            },
            {
                prop: "shuiehj",
                label: '税额',
                type: "input"
            }
        ],
        fp_searchdata: {
            faphm: "",
            kaiprq: [],
            goufmc: "",
            shuiehj: "",
        },
        fp_headData: [
            {
                title: "发票号码",
                prop: "faphm",
                width: "110",
                custom: true,
                issort: true,
            },
            {
                title: "开票日期",
                custom: true,
                prop: "kaiprq",
                width: 110,
                issort: true,
            },
            {
                title: "购方名称",
                custom: true,
                prop: "goufmc",
                width: 110,
                issort: true,
            },
            {
                title: "销方名称",
                custom: true,
                prop: "xiaofmc",
                width: 110,
                issort: true,
            },
            {
                title: "税额",
                custom: true,
                prop: "shuiehj",
                width: 100,
                issort: true,
            },
            {
                title: "备注",
                custom: true,
                prop: "businessMatchRemark",
                width: 100,
                issort: true,
            },
        ],
        fp_pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        },

        pz_jg_headData: [
            {
                title: "凭证号",
                custom: true,
                prop: "voucherNo",
                width: 110,
            },
            {
                title: "记账金额",
                custom: true,
                prop: "localAmount",
                width: 100,
            },
            {
                title: "凭证摘要",
                custom: true,
                prop: "voucherDesc",
                width: 110,
            },
            {
                title: "操作",
                custom: true,
                prop: "operate",
                width: 100,
            },
        ],
        fp_jg_headData: [
            {
                title: "发票号码",
                prop: "faphm",
                width: "110",
                custom: true
            },
            {
                title: "税额",
                custom: true,
                prop: "shuiehj",
                width: 100,
            },
            {
                title: "备注",
                custom: true,
                prop: "businessMatchRemark",
                width: 100,
            },
            {
                title: "操作",
                custom: true,
                prop: "operate",
                width: 100,
            },
        ]
    }
    return obj;
}
